export default __webpack_public_path__ + "static/30-e6811a747dcfd5fd187362eae688d414.png";